import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCalendarAlt } from 'react-icons/fa';

const PersistentCTA = () => (
  <motion.div
    initial={{ y: 80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ delay: 1.2, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    className="fixed bottom-6 right-6 z-50"
  >
    <Link to="/contact">
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.96 }}
        className="flex items-center gap-2.5 px-6 py-3.5 rounded-full text-sm font-semibold text-white tracking-wide"
        style={{
          background: 'linear-gradient(135deg, #f97316, #ec4899, #a855f7)',
          boxShadow: '0 4px 20px rgba(168,85,247,0.3), 0 1px 6px rgba(0,0,0,0.15)',
        }}
      >
        <FaCalendarAlt size={15} />
        <span className="hidden sm:inline whitespace-nowrap">Book a Consultation</span>
        <span className="sm:hidden">Book Now</span>
      </motion.div>
    </Link>
  </motion.div>
);

export default PersistentCTA;
